<template>
  <div>
    <div class="zrrlist">
      <!-- 耿彪增加 -->
      <div class="tit">
        <p>防汛管理制度</p>
        <cityselect v-on:citySelected="citySelected"></cityselect>
      </div>
      <ul class="list listb">
        <li>
          <div>
            <p class="titnames">地市名称</p>
          </div>
          <div>
            <p class="titnames">淤地坝数量</p>
          </div>
          <div>
            <p class="titnames1">落实率</p>
          </div>
        </li>
      </ul>
      <ul class="list">
        <li v-for="(item,i) in zhiduList" :key="i" :class="zhiduList.length-1==i?'ddd':''">
          <div>
            <p class="titnames">{{item.city}}</p>
          </div>
          <div>
            <p class="titnames">{{item.sum}}</p>
          </div>
          <div>
            <p class="titnames1" :style="item.rate > 60 ? 'color:#ff6464' : 'color:lime'">{{item.rate}}%</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="zrrlist">
      <div class="tit">
        <p>防汛预案</p>
        <cityselect v-on:citySelected="citySelected1"></cityselect>
      </div>
      <!-- 耿彪修改 -->
      <ul class="list listb">
        <li>
          <div>
            <p class="titnames">地市名称</p>
          </div>
          <div>
            <p class="titnames">淤地坝数量</p>
          </div>
          <div>
            <p class="titnames1">落实率</p>
          </div>
        </li>
      </ul>
      <ul class="list">
        <li v-for="(item,i) in yuanList" :key="i" :class="yuanList.length-1==i?'ddd':''">
          <div>
            <p class="titnames">{{item.city}}</p>
          </div>
          <div>
            <p class="titnames">{{item.sum}}</p>
          </div>
          <div>
            <p class="titnames1" :style="item.rate < 60 ? 'color:#ff6464' : 'color:lime'">{{item.rate}}%</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="zrrlist">
      <!-- 耿彪增加 -->
      <div class="tit">
        <p>防汛管理经费</p>
        <cityselect v-on:citySelected="citySelected2"></cityselect>
      </div>
      <ul class="list listb">
        <li>
          <div>
            <p class="titnames">地市名称</p>
          </div>
          <div>
            <p class="titnames">淤地坝数量</p>
          </div>
          <div>
            <p class="titnames1">洪水发生率</p>
          </div>
        </li>
      </ul>
      <ul class="list">
        <li v-for="(item,i) in jingfeiList" :key="i" :class="jingfeiList.length-1==i?'ddd':''">
          <div>
            <p class="titnames">{{item.city}}</p>
          </div>
          <div>
            <p class="titnames">{{item.sum}}</p>
          </div>
          <div>
            <p class="titnames1" :style="item.rate > 60 ? 'color:#ff6464' : 'color:lime'">{{item.rate}}%</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { fxZhidu, fxya, fxJingfei } from "@/api/api.js";
import cityselect from "../../components/cityselect/cityselect.vue";
export default {
  props: ["Nrssx"],
  data() {
    return {
      zhiduList: [],
      yuanList: [],
      jingfeiList: [],
    };
  },
  components: {
    cityselect: cityselect,
  },
  mounted() {
    let params = { type: 0 };
    this.zhiduFun(params);
    this.yuanFun(params);
    this.jingfeiFun(params);
  },
  watch: {},
  methods: {
    citySelected(val) {
      // console.log("selected---------->", val);
      let params = { type: val.id };
      this.zhiduFun(params);
    },
    citySelected1(val) {
      // console.log("selected1---------->", val);
      let params = { type: val.id };
      this.yuanFun(params);
    },
    citySelected2(val) {
      // console.log("selected2---------->", val);
      let params = { type: val.id };
      this.jingfeiFun(params);
    },
    zhiduFun(params) {
      fxZhidu(params).then((res) => {
        // console.log("制度",res.data)
        this.zhiduList = res.data;
      });
    },
    yuanFun(params) {
      fxya(params).then((res) => {
        // console.log("预案",res.data)
        this.yuanList = res.data;
      });
    },
    jingfeiFun(params) {
      fxJingfei(params).then((res) => {
        // console.log("经费",res.data)
        this.jingfeiList = res.data;
      });
    },
  },
};
</script>

<style scoped>
.totalPie,
.zrrlist {
  width: 100%;
  height: 250px;
  /* height: auto; */
  background: url(../../common/images/contentborder.png) no-repeat center;
  background-size: 100% 100%;
  overflow: hidden;
}

.zrrlist {
  margin-top: 15px;
  padding-bottom: 15px;
}

.tit {
  padding-bottom: 5px;
  border-bottom: 1px solid #098dc7;
}

.tit ul {
  margin-top: 5px;
}

.list {
  width: 90%;
  margin: 0 auto;

  height: calc(100% - 75px);
  height: -webkit-calc(100% - 75px);
  height: -moz-calc(100% - 75px);
  overflow: auto;
}
.list li {
  width: 100%;
  height: 35px;
  border-top: 1px solid #098dc7;
  cursor: pointer;
}
.ddd {
  border-bottom: 1px solid #098dc7;
}

.list li div:nth-child(1) {
  width: 30%;
  float: left;
  height: 35px;
}
.list li div:nth-child(2) {
  width: 40%;
  float: left;
}
.list li div:nth-child(3) {
  width: 30%;
  float: left;
}
.titnames {
  line-height: 35px;
  text-align: center;
  color: #fff;
  font-size: 12px;
  border-right: 1px solid #098dc7;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.titnames1 {
  line-height: 35px;
  text-align: center;
  color: #fff;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sta1 {
  height: 35px;
  overflow: hidden;
  border-radius: 12px;
  margin: 0 auto;
  text-align: center;
  line-height: 35px;
  color: #fff;
  font-size: 12px;
  padding-right: 15px;
}
.listb {
  border-bottom: none;
  height: 36px;
  margin-top: 10px;
}
.listb li {
  background: rgba(0, 179, 254, 0.5);
  height: 35px;
}
.listb li div p {
  line-height: 30px !important;
  margin-top: 0px;
}
.list li:nth-child(even) {
  background: rgba(0, 179, 254, 0.1);
}
.qdimg {
  width: 30px;
  height: 30px;
  margin-top: 2px;
  margin-left: 40%;
}
</style>
